import { apiSlice } from "./apiSlice";

export const projectSettingsSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => {
        return {
            getProjectSettings: builder.query({
                query: ({ projectId }) => ({
                    url: `ProjectSettings/${projectId}`
                }),
                providesTags: ["ProjectSettings"]
            }),

            updateProjectSettings: builder.mutation({
                query: (body) => ({
                    url: `ProjectSettings`,
                    method: "POST",
                    body: body
                }),
                invalidatesTags: ["ProjectSettings"]
            }),

        }
    }
})


export const { useGetProjectSettingsQuery, useUpdateProjectSettingsMutation } = projectSettingsSlice